import { AxiosResponse } from 'axios';
import api from './api';

export default class AuthorizationService {
    static async login(login: string, password: string): Promise<AxiosResponse> {
        return api.post('/auth/login', { login: login, password: password });
    }

    //-------------------------------------------------------------------------------------------------
    static async logout(): Promise<AxiosResponse> {
        return api.get('/auth/logout');
    }

    static async refresh(): Promise<AxiosResponse> {
        return api.get('/auth/refresh');
    }
}
